/* ============================================================
   LOBY — shared front-end utilities (vanilla, no libraries)
   Loaded with `defer` from theme.liquid.
   Currently: scroll-reveal via IntersectionObserver.
   Interactive sections (size showcase, before/after) ship
   their own scoped scripts inside their .liquid files.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll('.loby-reveal');
    if (!els.length) return;

    // No IO support or reduced motion → show everything immediately.
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target); // trigger once only
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* Expose so dynamically injected sections (Shopify editor) can re-scan. */
  window.Loby = window.Loby || {};
  window.Loby.initReveal = initReveal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  /* Re-run when a section is (re)rendered in the theme editor. */
  document.addEventListener('shopify:section:load', initReveal);
})();
